import React from "react";
import { StarIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { testimonials } from "../data/content";
export function Testimonials() {
  return <section className="bg-plum-50 px-5 py-16 md:py-24" data-id="element-271" data-mp="3fzntrlbxjb1d">
      <div className="mx-auto max-w-5xl" data-id="element-272" data-mp="3fy30s059k05m">
        <h2 className="text-center font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-273" data-mp="3b0krg8nc3ix3">
          What dentists are saying about <em className="text-plum-600" data-id="element-274" data-mp="36zqyh0v1bdxc">the system</em>
        </h2>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-275" data-mp="31zd3okig20h9">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_2px_20px_-8px_rgba(42,16,69,0.18)]" data-id="element-276" data-mp="2x09vir763e52">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-277" data-mp="2s2rtzlvhc173">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden data-id="element-278" data-mp="v7c7d8oc59qg" data-mpi={i} />)}
              </div>
              <p className="mt-4 flex-1 text-[16px] leading-relaxed text-ink/85" data-id="element-279" data-mp="h67wpwq6ta6o">“{t.quote}”</p>
              <div className="mt-6 flex items-center gap-4 border-t border-plum-100 pt-5" data-id="element-280" data-mp="m4rmy9btd84u">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-plum-100" loading="lazy" data-id="element-281" data-mp="77s8c1ijof0v" />
                <div data-id="element-282" data-mp="c7wrjzau7nus">
                  <p className="font-bold text-ink" data-id="element-283" data-mp="c73rtiaapym5">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-284" data-mp="zw68onx3vnfl">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-285" data-mp="14xlpg3s937s6">
          <CtaButton label="I want the same results in my practice" data-id="element-286" data-mp="q6wg76yco2qy" />
        </div>
      </div>
    </section>;
}